import { NavigateFunction } from 'react-router-dom'
import { ReconciliationStep } from '../models/reconciliation'
import paths from './paths'
import {
  goToReconciliationAccountPage,
  goToReconciliationContactsPage,
  goToReconciliationLeasedAssetsPage,
  goToReconciliationPropertyAssetsPage,
  GoToReconcilationPagesParams,
  goToReconciliationSummaryPage,
} from './routeActions'

interface OrderedStep {
  step: ReconciliationStep
  path: string
  goTo: (navigate: NavigateFunction, params: GoToReconcilationPagesParams) => void
}

const orderedSteps: OrderedStep[] = [
  { step: ReconciliationStep.AccountInformation, path: paths.reconciliationAccountInformation, goTo: goToReconciliationAccountPage },
  { step: ReconciliationStep.Contacts, path: paths.reconciliationContacts, goTo: goToReconciliationContactsPage },
  { step: ReconciliationStep.PropertyAssetList, path: paths.reconciliationPropertyAssets, goTo: goToReconciliationPropertyAssetsPage },
  { step: ReconciliationStep.LeasedAssetList, path: paths.reconciliationLeasedAssets, goTo: goToReconciliationLeasedAssetsPage },
  { step: ReconciliationStep.Summary, path: paths.reconciliationSummary, goTo: goToReconciliationSummaryPage },
]

function findNextStep(completedSteps: ReconciliationStep[]): OrderedStep {
  return orderedSteps.find(({ step }) => !completedSteps.includes(step)) ?? orderedSteps[0]
}

export function getStepFromPath(pathname: string): ReconciliationStep | null {
  if (pathname.includes('/account')) {
    return ReconciliationStep.AccountInformation
  }

  if (pathname.includes('/contacts')) {
    return ReconciliationStep.Contacts
  }

  if (pathname.includes('/assets')) {
    return ReconciliationStep.PropertyAssetList
  }

  if (pathname.includes('/leased-assets')) {
    return ReconciliationStep.LeasedAssetList
  }

  if (pathname.includes('/summary')) {
    return ReconciliationStep.Summary
  }

  return null
}

export function mapToStep(stepName: string): ReconciliationStep {
  if (stepName === 'Account Information') {
    return ReconciliationStep.AccountInformation
  }

  if (stepName === 'Contacts') {
    return ReconciliationStep.Contacts
  }

  if (stepName === 'Contacts') {
    return ReconciliationStep.Contacts
  }

  if (stepName === 'Property Asset List') {
    return ReconciliationStep.PropertyAssetList
  }

  if (stepName === 'Leased Asset List') {
    return ReconciliationStep.LeasedAssetList
  }

  if (stepName === 'Summary & Signature') {
    return ReconciliationStep.Summary
  }

  if (stepName === 'Reconciled') {
    return ReconciliationStep.Reconciled
  }

  throw new Error(`Could not map step "${stepName}"`)
}

export function nextStep(
  navigate: NavigateFunction,
  accountId: number | string,
  completedSteps: ReconciliationStep[],
): void {
  findNextStep(completedSteps).goTo(navigate, { accountId })
}

export function getNextStepPath(accountId: number | string, completedSteps: ReconciliationStep[]): string {
  return findNextStep(completedSteps).path.replace(':accountId', accountId.toString())
}

export function hasWorkflowBeenCompleted(completedSteps: ReconciliationStep[]): boolean {
  const hasBeenCompleted = [
    ReconciliationStep.AccountInformation,
    ReconciliationStep.Contacts,
    ReconciliationStep.PropertyAssetList,
    ReconciliationStep.LeasedAssetList,
    ReconciliationStep.Summary,
    ReconciliationStep.Reconciled,
  ].every((step) => completedSteps.includes(step))

  return hasBeenCompleted
}
